
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import UploadPage from '../pages/upload/page';
import PlaylistsPage from '../pages/playlists/page';
import BrowsePage from '../pages/browse/page';
import RadioPage from '../pages/radio/page';
import LibraryPage from '../pages/library/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/upload',
    element: <UploadPage />
  },
  {
    path: '/playlists',
    element: <PlaylistsPage />
  },
  {
    path: '/browse',
    element: <BrowsePage />
  },
  {
    path: '/radio',
    element: <RadioPage />
  },
  {
    path: '/library',
    element: <LibraryPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
